"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var IconQuestion = function IconQuestion(_ref) {
  var size = _ref.size,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    className: "tooltip--icon",
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      fill: "#767676"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.8359 14.2109V13.6328C10.8359 13.1328 10.9427 12.6979 11.1562 12.3281C11.3698 11.9583 11.7604 11.5651 12.3281 11.1484C12.875 10.7578 13.2344 10.4401 13.4062 10.1953C13.5833 9.95052 13.6719 9.67708 13.6719 9.375C13.6719 9.03646 13.5469 8.77865 13.2969 8.60156C13.0469 8.42448 12.6979 8.33594 12.25 8.33594C11.4688 8.33594 10.5781 8.59115 9.57812 9.10156L8.72656 7.39062C9.88802 6.73958 11.1198 6.41406 12.4219 6.41406C13.4948 6.41406 14.3464 6.67188 14.9766 7.1875C15.612 7.70312 15.9297 8.39062 15.9297 9.25C15.9297 9.82292 15.7995 10.3177 15.5391 10.7344C15.2786 11.151 14.7839 11.6198 14.0547 12.1406C13.5547 12.5104 13.237 12.7917 13.1016 12.9844C12.9714 13.1771 12.9062 13.4297 12.9062 13.7422V14.2109H10.8359ZM10.5859 16.8828C10.5859 16.4453 10.7031 16.1146 10.9375 15.8906C11.1719 15.6667 11.513 15.5547 11.9609 15.5547C12.3932 15.5547 12.7266 15.6693 12.9609 15.8984C13.2005 16.1276 13.3203 16.4557 13.3203 16.8828C13.3203 17.2943 13.2005 17.6198 12.9609 17.8594C12.7214 18.0938 12.388 18.2109 11.9609 18.2109C11.5234 18.2109 11.1849 18.0964 10.9453 17.8672C10.7057 17.6328 10.5859 17.3047 10.5859 16.8828Z",
      fill: "white"
    })]
  }));
};
var _default = IconQuestion;
exports["default"] = _default;